import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
/* empty css          */
var Sizes = /* @__PURE__ */ ((Sizes2) => {
  Sizes2[Sizes2["small"] = 16] = "small";
  Sizes2[Sizes2["medium"] = 24] = "medium";
  Sizes2[Sizes2["large"] = 32] = "large";
  return Sizes2;
})(Sizes || {});
var Colors = /* @__PURE__ */ ((Colors2) => {
  Colors2["gold"] = "gold";
  Colors2["black"] = "black";
  return Colors2;
})(Colors || {});
const Star = ({ className, fill, color = "gold", size }) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: classnames(
      "store-rating-star",
      {
        "store-rating-star--empty": fill < 0.5,
        "store-rating-star--half": fill === 0.5,
        "store-rating-star--full": fill > 0.5,
        "store-rating-star__size--large": size === 32,
        "store-rating-star__size--medium": size === 24,
        "store-rating-star__size--small": size === 16
        /* small */
      },
      className
    )
  },
  /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("store-rating-star__foreground", {
        "store-rating-star__foreground--default-color": color === "gold",
        "store-rating-star__foreground--black": color === "black"
        /* black */
      })
    },
    /* @__PURE__ */ React.createElement("div", { className: "store-rating-star__foreground-container" }, /* @__PURE__ */ React.createElement(Icon, { name: "star", width: size, height: size }))
  ),
  /* @__PURE__ */ React.createElement("div", { className: "store-rating-star__background" }, /* @__PURE__ */ React.createElement(Icon, { name: "star", width: size, height: size }))
);
export {
  Colors,
  Sizes,
  Star,
  Star as default
};
//# sourceMappingURL=Star.js.map
